import { GET, POST, PUT, DELETE } from "../utils/restUtils";
import { Auth } from 'aws-amplify';
import _ from "lodash";

const getToken = async () => {
  let session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
}

export const getShoots = async config => {
  let token = await getToken();
  return await GET("/shoot",{
    headers: {
      'Authorization': token
    }
  });
};

export const addShoot = async (body, config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  return POST("/shoot", body, config);
};

export const getOneShoot = async (urlParams, config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic and created_at is required!");
  
  else return GET(`/shoot/${urlParams.clinic}/${urlParams.created_at}`, config);
};

export const deleteShoot = async (urlParams, config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clnic and created_at is required!");
  else return DELETE(path, config);
};

export const updateShoot = async (urlParams, data, config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clnic and created_at is required!");
  else return PUT(path, data, config);
};

export const changeShootDetails = async (urlParams, data, config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/details`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clnic and created_at is required!");
  else return PUT(path, data, config);
};

export const getShootStatus = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/status`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clnic and created_at is required!");
  else return GET(path, config);
};

//LANGUAGE
export const getShootLanguages = async (urlParams, config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/language`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clnic and created_at is required!");
  else return GET(path, config);
};

export const addLanguageToShoot = async (urlParams, data, config) => {
  let token = await getToken();
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/language`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clnic and created_at is required!");
  else{ 
    console.log('serviceslanguage', path, data, config);
    return POST(path, data, config);}
};

export const deleteLanguageToShoot = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/language/${
    urlParams.language
  }`;
  if (!urlParams.clinic && !urlParams.created_at && !urlParams.language)
    return new Error("clinic, created_at, and language is required!");
  else return DELETE(path, config);
};

//SERVICE
export const getShootServices = async (urlParams, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/service`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic and created_at is required!");
  else return GET(path, config);
};

export const addServiceToShoot = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/service`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic and created_at is required!");
  else{
    console.log('serviceservices', path, data, config);
    return POST(path, data, config);}
};

export const deleteServiceToShoot = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/service/${
    urlParams.service
  }`;
  if (!urlParams.clinic && !urlParams.created_at && !urlParams.service)
    return new Error("clinic, created_at, and language is required!");
  else return DELETE(path, config);
};

//STAFF
export const getShootStaff = async (urlParams, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/staff`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic and created_at is required!");
  else return GET(path, config);
};

export const addStaffToShoot = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/staff`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic and created_at is required!");
  else return POST(path, data, config);
};

export const deleteStaffToShoot = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/staff/${
    urlParams.staff
  }`;
  if (!urlParams.clinic && !urlParams.created_at && !urlParams.staff)
    return new Error("clinic, created_at, and language is required!");
  else return DELETE(path, config);
};

//SHOTS
export const deleteShootShots = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/shots`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic, created_at, and language is required!");
  else if (!(data instanceof Array))
    return new Error("data parameter must be Array!");
  else return DELETE(path, _.assign({}, { data: { shots: data } }, config));
};

export const getShootShots = async (urlParams, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/shots`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic and created_at is required!");
  else return GET(path, config);
};

export const addShotsToShoot = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/shots`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic, created_at, and language is required!");
  else if (!(data instanceof Array))
    return new Error("data parameter must be Array!");
  else return POST(path, _.assign({}, { shots: data }), config);
};

export const getOneShootShot = async (urlParams, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/shots/${
    urlParams.shotId
  }`;
  if (!urlParams.clinic && !urlParams.created_at && urlParams.shotId)
    return new Error("clinic, created_at, and shot id is required!");
  else return GET(path, config);
};

export const updateShootShot = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/shots/${
    urlParams.shotId
  }`;
  if (!urlParams.clinic && !urlParams.created_at && urlParams.shotId)
    return new Error("clinic, created_at, and shot id is required!");
  else if (!data.completed && !data.checked && !data.approved && !data.comment)
    return new Error(
      "Http request body must be object with completed, checked, comment and approved attributes"
    );
  else return PUT(path, data, config);
};

export const checkShootShot = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  console.log(urlParams);
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/shots/check`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic, created_at, and shot id is required!");
  else return POST(path, data, config);
};

export const markShootComplete = async (urlParams, data, config) => {
  let token = await getToken()
  let headers = {
    'Authorization': token
  }
  config = _.assign({},config,{headers})
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}`;
  if (!urlParams.clinic && !urlParams.created_at)
    return new Error("clinic and created_at os required");
  else return PUT(path, data, config);
};

export default {
  getOneShoot,
  addLanguageToShoot,
  addShotsToShoot,
  addStaffToShoot,
  deleteLanguageToShoot,
  deleteServiceToShoot,
  deleteShoot,
  deleteShootShots,
  deleteStaffToShoot,
  changeShootDetails,
  addServiceToShoot,
  getOneShootShot,
  getShootLanguages,
  getShoots,
  getShootServices,
  getShootShots,
  getShootStaff,
  addShoot,
  updateShoot,
  updateShootShot,
  checkShootShot,
  markShootComplete,
  getShootStatus
};
